import { render } from "./saveProgramme.vue?vue&type=template&id=a06d0e56&scoped=true"
import script from "./saveProgramme.vue?vue&type=script&lang=js"
export * from "./saveProgramme.vue?vue&type=script&lang=js"

import "./saveProgramme.vue?vue&type=style&index=0&id=a06d0e56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06d0e56"]])

export default __exports__